import { Box, Divider, Group, Radio, Select } from '@byecode/ui'
import type { FlowNode, LoopNodeActionConfig, NodeTypes } from '@lighthouse/shared'
import { ListItem4ByecodeUi, LoopErrorHandlerEnum, LoopTypeEnum, loopTypeMap, nodeTypeOptions } from '@lighthouse/shared'
import React from 'react'

import { useCurrentAppId, useCurrentEnvId } from '@/hooks/useApplication'
import { useDataSourceList } from '@/hooks/useDataSource'

import * as SC from '../../styles'
import { SelectMultipleRecord } from '../component/SelectMultipleRecord'
import { RecordsConfig } from './RecordsConfig'
import { TimesConfig } from './TimesConfig'

interface LoopNodeActionConfigureProps {
    nodeType?: NodeTypes
    nodeName: string
    allParentNodes: FlowNode[]
    value: LoopNodeActionConfig
    onChange: (value: LoopNodeActionConfig) => void
}

export const LoopNodeActionConfigure: React.FC<LoopNodeActionConfigureProps> = ({
    nodeType,
    nodeName,
    allParentNodes,
    value,
    onChange
}) => {
    const loopType = value?.loopType
    const appId = useCurrentAppId()
    const envId = useCurrentEnvId()

    const dataSourceList = useDataSourceList(appId, envId)

    return (
        <SC.Container>
            <Group label="循环方式">
                <ListItem4ByecodeUi>
                    <SC.FormItemLabelWrapper>
                        <SC.FormItemLabel>选择循环方式</SC.FormItemLabel>
                    </SC.FormItemLabelWrapper>
                    <SC.FormItemContent>
                        <Select
                            value={loopType}
                            options={loopTypeMap}
                            onChange={val => {
                                onChange({ ...value, loopType: val } as LoopNodeActionConfig)
                            }}
                        />
                    </SC.FormItemContent>
                </ListItem4ByecodeUi>
                {loopType === LoopTypeEnum.BASE_ON_RECORDS && (
                    <SelectMultipleRecord
                        allParentNodes={allParentNodes}
                        value={value?.recordsConfig?.nodeId}
                        onChange={nodeId => onChange({ ...value, recordsConfig: { ...value?.recordsConfig, nodeId } })}
                    />
                )}
            </Group>
            {loopType === LoopTypeEnum.BASE_ON_RECORDS ? (
                <RecordsConfig
                    allParentNodes={allParentNodes}
                    nodeName={nodeName}
                    value={value?.recordsConfig}
                    onChange={recordsConfig => onChange({ ...value, recordsConfig })}
                />
            ) : (
                <TimesConfig
                    dataSourceList={dataSourceList}
                    allParentNodes={allParentNodes}
                    nodeName={nodeName}
                    value={value?.timesConfig}
                    onChange={timesConfig => onChange({ ...value, timesConfig })}
                />
            )}
            <Divider color="var(--color-gray-200)" />
            <Group label="循环中的子流程出现错误时">
                <Box px={8}>
                    <Radio.Group
                        name="config.loopErrorHandler"
                        value={value?.loopErrorHandler}
                        style={{ flexDirection: 'column', gap: 0 }}
                        onChange={loopErrorHandler => onChange({ ...value, loopErrorHandler } as LoopNodeActionConfig)}
                    >
                        <Radio size="sm" label="跳过并进入下一次循环" value={LoopErrorHandlerEnum.CONTINUE} />
                        <Radio size="sm" label="结束循环，继续后面的流程" value={LoopErrorHandlerEnum.BREAK} />
                        <Radio size="sm" label="结束循环，不继续后面的流程" value={LoopErrorHandlerEnum.RETURN} />
                    </Radio.Group>
                </Box>
            </Group>
        </SC.Container>
    )
}
